export const zhTW: { [k: string]: string } = {
  
}
